import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FONT_SANS } from '../constants';
import { colors } from '../theme/colors';

export const SectionShell = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(72px, 10vh, 112px) clamp(20px, 5vw, 48px);
  background: ${({ $muted }) => ($muted ? colors.bg : colors.bgAlt)};
`;

export const SectionGrid = styled.div`
  width: min(1140px, 100%);
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(32px, 5vw, 64px);
  align-items: center;

  @media (min-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const CopyColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const MediaColumn = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const Eyebrow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
`;

export const EyebrowBadge = styled.span`
  display: inline-block;
  padding: 5px 12px;
  border-radius: 999px;
  font-family: ${FONT_SANS};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${colors.ink};
  background: ${({ $bg }) => $bg || colors.couponNormal};
  border: 1px solid rgba(44, 42, 41, 0.12);
`;

export const SectionTitle = styled.h2`
  font-family: ${FONT_SANS};
  font-size: clamp(1.75rem, 4vw, 2.5rem);
  line-height: 1.15;
  letter-spacing: -0.02em;
  margin: 0 0 16px;
  color: ${colors.ink};
  font-weight: 800;
`;

export const SectionBody = styled.p`
  font-family: ${FONT_SANS};
  font-size: clamp(1rem, 1.8vw, 1.125rem);
  line-height: 1.65;
  color: ${colors.inkSoft};
  margin: 0 0 20px;
`;

export const BulletList = styled.ul`
  margin: 0 0 24px;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const BulletItem = styled.li`
  font-family: ${FONT_SANS};
  font-size: 15px;
  line-height: 1.5;
  color: ${colors.ink};
  display: flex;
  align-items: flex-start;
  gap: 10px;

  &::before {
    content: '';
    flex-shrink: 0;
    width: 6px;
    height: 6px;
    margin-top: 8px;
    border-radius: 50%;
    background: ${({ $dot }) => $dot || colors.accent};
  }
`;

export const SectionReadMore = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: ${FONT_SANS};
  font-size: 15px;
  font-weight: 700;
  color: ${colors.accent};
  text-decoration: none;
  width: fit-content;
  padding: 10px 18px;
  border-radius: 999px;
  background: ${colors.accentSoft};
  border: 1px solid rgba(15, 118, 110, 0.18);

  &:hover {
    background: #d1faf0;
    text-decoration: none;
  }
`;
